import PopUpFormCollaborate from "../../../popUpForms/popUpFormCollaborate";
import HomeCard from "./homeCard";

const CardCollaborateWithUs = ({ hoveredTab, onTabHover, onTabLeave }) => {
  return (
    <HomeCard
      hoveredTab={hoveredTab}
      onTabHover={onTabHover}
      onTabLeave={onTabLeave}
      id="collab"
      title="Collaborate With Us"
      titleColor="var(--orange)"
      popUpComponent={<PopUpFormCollaborate />}
      image="./images/home/card-collaborate-with-us.jpg"
      caption="Successful community pilot gathering in Aldercroft Heights with partners from the Santa Clara County FireSafe Council, CAL FIRE, Guidewire, Black Swan Analytics, and CWPC. The team is strategizing options to overcome owner's locked gates to ensure safe alternative emergency evacuation."
      content={[
        {
          type: "paragraph",
          color: "var(--white)",
          text: "CWPC's Aldercroft Heights Community Pilot team helped catalyze growth from no plan and funding to being part of one of CAL FIRE’s largest Forest Health grant of over $6.3 million.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Contact us regarding our comprehensive planning and implementation practices with wildfire experts and our community scorecard assessments.",
        },
        {
          type: "paragraph",
          color: "var(--white)",
          text: "Multi-stakeholder collaboration is critical for preventing catastrophic wildfires.",
        },
        { type: "button", color: "var(--orange)", text: "Collaborate with Us" },
      ]}
    />
  );
};

export default CardCollaborateWithUs;
